import { BusinessController } from '@/business/modules/business';

const actions = {
	getInstance() {
		return new BusinessController();
	},

	getBusinessInformation(shopId) {
		return this.getInstance().getBusinessInformation(shopId);
	},

	getBusinessProfileBySlug(payload) {
		return this.getInstance().getBusinessProfileBySlug(payload);
	},

	updataBusinessProfile(payload) {
		return this.getInstance().updataBusinessProfile(payload);
	},

	singupAsBusiness(data) {
		return this.getInstance().singupAsBusiness(data);
	},

	searchOnBusiness(data) {
		return this.getInstance().searchOnBusiness(data);
	},

	getBusinessesByCity(data) {
		return this.getInstance().getBusinessesByCity(data);
	},

	getCustomersByType(payload) {
		if (typeof payload === 'string') return this.getInstance().getCustomersByType(payload);
		return this.getInstance().getCustomersByType(payload.type, {
			page: payload.page,
			size: payload.size,
		});
	},

	inquiryBusiness() {
		return this.getInstance().inquiryBusiness();
	},

	requestValidateBusiness(payload) {
		return this.getInstance().requestValidateBusiness(payload);
	},

	sendSms(payload) {
		return this.getInstance().sendSms(payload);
	},

	getCustomerClubDashboard(params) {
		return this.getInstance().getCustomerClubDashboard(params);
	},

	submitRating(payload) {
		return this.getInstance().submitRating(payload);
	},

	makeUserVIP(userId) {
		return this.getInstance().makeUserVIP(userId);
	},

	makeUserNormal(userId) {
		return this.getInstance().makeUserNormal(userId);
	},

	createCustomer(payload) {
		return this.getInstance().createCustomer(payload);
	},

	getPendingBusinesses(page) {
		return this.getInstance().getPendingBusinesses(page);
	},

	assignCategoriesToBusiness(payload) {
		return this.getInstance().assignCategoriesToBusiness(payload);
	},

	getCategoriesOfBusiness(businessId) {
		return this.getInstance().getCategoriesOfBusiness(businessId);
	},

	verifyBusiness(params) {
		return this.getInstance().verifyBusiness(params);
	},

	updateReserveTimePayment(enabled) {
		return this.getInstance().updateReserveTimePayment(enabled);
	},

	updateOnlineReservation(enabled) {
		return this.getInstance().updateOnlineReservation(enabled);
	},

	updateCancellationPolicy(data) {
		return this.getInstance().updateCancellationPolicy(data);
	},

	createSlotTime(data) {
		return this.getInstance().createSlotTime(data);
	},
};

export default actions;
